import { useState } from 'react'
import { useLang } from '../i18n/LanguageContext'
import './ContactPage.css'

const SLUG = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/
const HOST = /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/

/**
 * What the visitor typed, as the host of the forening's own site: a plain name is a forening on the platform
 * (name.communitynord.com), a domain is the forening's own. Anything else is not an address.
 */
function toHost(input) {
  const typed = input.trim().toLowerCase().replace(/^https?:\/\//, '').split('/')[0]
  if (SLUG.test(typed)) {
    return `${typed}.communitynord.com`
  }
  return HOST.test(typed) ? typed : null
}

/**
 * Each forening signs in on its own address, so there is no single place to log in. This asks which forening and takes the
 * visitor there. (The header used to link to app.communitynord.com, which is not a forening and answered "no active forening".)
 */
function LoginPage() {
  const { t } = useLang()
  const [value, setValue] = useState('')
  const [invalid, setInvalid] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    const host = toHost(value)
    if (!host) {
      setInvalid(true)
      return
    }
    window.location.assign(`https://${host}/Account/Login`)
  }

  return (
    <div className="contact-page">
      <section className="hero">
        <div className="container">
          <h1 className="hero-title" style={{ textAlign: 'center' }}>{t('login.title')}</h1>
          <p className="hero-subtitle" style={{ textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
            {t('login.subtitle')}
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ maxWidth: '520px' }}>
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label htmlFor="forening" className="form-label">{t('login.label')}</label>
              <input
                type="text"
                id="forening"
                name="forening"
                className="form-input"
                placeholder={t('login.placeholder')}
                value={value}
                onChange={(e) => { setValue(e.target.value); setInvalid(false) }}
                autoComplete="off"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck="false"
                aria-invalid={invalid}
                aria-describedby="forening-hint"
                autoFocus
              />
              <p id="forening-hint" className="text-sm" style={{ marginTop: 'var(--space-2)' }}>
                {invalid ? t('login.invalid') : t('login.hint')}
              </p>
            </div>
            <button type="submit" className="btn btn-primary btn-lg">{t('login.button')}</button>
          </form>
        </div>
      </section>
    </div>
  )
}

export default LoginPage
